<template>
	<div class="" style="position: relative;">
		<div class="imgBox">
			<img src="../../assets/siji.png">
		</div>
		<div
			style="position: fixed;bottom: 0px;left:0;right:0;text-align:center;background: rgba(0, 0, 0, 0.5);padding: 8px;color: white;">
			<!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44190002005619"
				class="beian">
				<img src="@/static/image/beian.png" alt="备案图标" />
				<div>粤公网安备xxxxxxx号</div>
			</a> -->
			<a href="http://beian.miit.gov.cn" target="_blank" style="color: white;">粤ICP备2023143355号</a>
			<span> | 省拼达 版权所有 ©2025</span>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Dashboard',
	components: {},
	methods: {}
}
</script>

<style scoped>
.imgBox {
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
}

.imgBox img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
</style>
